import { render, staticRenderFns } from "./PrivateLiveEndConfirm.vue?vue&type=template&id=61be4d24&"
import script from "./PrivateLiveEndConfirm.vue?vue&type=script&lang=ts&"
export * from "./PrivateLiveEndConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports